import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Card, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import LogoutButton from "./LogoutButton";
import { loginRequest, apiTokenRequest } from "../config/authConfig";

const Welcome: React.FC = () => {
  const { accounts, instance } = useMsal();
  const activeAccount = accounts[0];
  const [isLoadingApi, setIsLoadingApi] = useState(false);

  // ----------------------------
  // Función para llamar al backend con token
  // ----------------------------
  const callBackendAPI = async () => {
    setIsLoadingApi(true);
    try {
      console.log("Iniciando llamada a la API backend...");

      // Obtener token de acceso para la API
      const tokenResponse = await instance.acquireTokenSilent({
        ...apiTokenRequest,
        account: activeAccount,
      });

      const accessToken = tokenResponse.accessToken;
      console.log("Token para API obtenido correctamente");
      console.log("JWT API Token:", accessToken);
      console.log("Token length:", accessToken.length);

      // Llamada a tu API backend
      const res = await fetch("https://back-sqai-sandbox.sqai.ai/api/me", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        mode: "cors",
        //credentials: "include",
      });

      console.log("Respuesta recibida, status:", res.status);

      if (res.ok) {
        const data = await res.json();
        console.log("JWT válido:", data);
        alert("Respuesta exitosa de la API. Ver consola para más detalles.");
      } else {
        const errorText = await res.text();
        console.error("Error en backend:", errorText);
        alert(`Error: Token inválido o expirado (Status: ${res.status})`);
      }
    } catch (error) {
      console.error("Error al llamar a la API backend:", error);
      if (error instanceof TypeError && error.message.includes("Failed to fetch")) {
        alert(
          `Error de CORS o conectividad:\n${error.message}\nVerifica que tu backend permita CORS desde este dominio y la URL sea correcta.`
        );
      } else if (
        error &&
        typeof error === "object" &&
        "name" in error &&
        error.name === "InteractionRequiredAuthError"
      ) {
        alert("Se requiere volver a autenticar. Cierra sesión e inicia nuevamente.");
      } else {
        const errorMessage = error instanceof Error ? error.message : String(error);
        alert(`Error inesperado: ${errorMessage}`);
      }
    } finally {
      setIsLoadingApi(false);
    }
  };

  // ----------------------------
  // Función para llamar al endpoint /pin (con token)
  // ----------------------------
  const callPinEndpoint = async () => {
    setIsLoadingApi(true);
    try {
      console.log("Llamando endpoint /pin...");

      // Obtener token de acceso para la API
      const tokenResponse = await instance.acquireTokenSilent({
        ...apiTokenRequest,
        account: activeAccount,
      });

      const accessToken = tokenResponse.accessToken;
      console.log("Token para /pin obtenido correctamente");
      console.log("JWT PIN Token:", accessToken);
      console.log("Token length:", accessToken.length);

      const res = await fetch("https://back-sqai-sandbox.sqai.ai/api/pin", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        mode: "cors",
        //credentials: "include",
      });

      console.log("Respuesta /pin recibida, status:", res.status);

      if (res.ok) {
        const data = await res.json();
        console.log("Respuesta /pin:", data);
        alert(`Endpoint /pin responde exitosamente. Ver consola para más detalles.`);
      } else {
        const errorText = await res.text();
        console.error("Error en /pin:", errorText);
        alert(`Error en /pin (Status: ${res.status}): ${errorText}`);
      }
    } catch (error) {
      console.error("Error al llamar /pin:", error);
      if (error instanceof TypeError && error.message.includes("Failed to fetch")) {
        alert(`Error de CORS o conectividad en /pin: ${error.message}`);
      } else if (
        error &&
        typeof error === "object" &&
        "name" in error &&
        error.name === "InteractionRequiredAuthError"
      ) {
        alert("Se requiere volver a autenticar. Cierra sesión e inicia nuevamente.");
      } else {
        const errorMessage = error instanceof Error ? error.message : String(error);
        alert(`Error inesperado en /pin: ${errorMessage}`);
      }
    } finally {
      setIsLoadingApi(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8}>
          <div className="welcome-container">
            <h1 className="display-4 mb-4">Bienvenido a Demo Azure AD</h1>

            <Alert variant="success" className="mb-4">
              <Alert.Heading>¡Sesión iniciada correctamente!</Alert.Heading>
              <p className="mb-0">
                Hola <strong>{activeAccount?.name ?? activeAccount?.username ?? "Usuario"}</strong>, has iniciado sesión exitosamente con Azure AD.
              </p>
            </Alert>

            <Card className="text-center mb-4">
              <Card.Body>
                <Card.Title>¿Qué deseas hacer?</Card.Title>
                <Card.Text>
                  Puedes ver tu perfil de usuario o explorar las funcionalidades de la aplicación.
                </Card.Text>
                <div className="d-flex justify-content-center gap-2 flex-wrap">
                  <Button as={Link as any} to="/profile" variant="primary" size="lg">
                    Ver Mi Perfil
                  </Button>
                  <Button onClick={callBackendAPI} variant="success" size="lg" disabled={isLoadingApi}>
                    {isLoadingApi ? "Consultando..." : "Consultar APIS Backend"}
                  </Button>
                  <Button onClick={callPinEndpoint} variant="info" size="lg" disabled={isLoadingApi}>
                    {isLoadingApi ? "Probando..." : "Test PIN"}
                  </Button>
                </div>
              </Card.Body>
            </Card>

            <div className="text-center">
              <p className="text-muted mb-2">¿Deseas cerrar tu sesión?</p>
              <LogoutButton />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Welcome;